import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getStorageVariable } from "../../utils/storage"
import { STORAGE_ENCRYPTED_DATA, STORAGE_SESSION_ACTIVE, WEB_PORTALS } from "../../constants"
import { LOGIN, SYSTEM_LOGIN } from "../../routes"

interface ProtectedRouteProps {
  children: React.ReactNode
}

const { slovakFtNews, slovakCryptoNews } = WEB_PORTALS

export const ProtectedPage: React.FC<ProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate()
  const isSystemAuthenticated = getStorageVariable(STORAGE_SESSION_ACTIVE) === "true"
  const isHomeEnabled =
    getStorageVariable(`${slovakFtNews}${STORAGE_ENCRYPTED_DATA}`) !== "" &&
    getStorageVariable(`${slovakCryptoNews}${STORAGE_ENCRYPTED_DATA}`) !== ""

  useEffect(() => {
    if (!isSystemAuthenticated) {
      navigate(SYSTEM_LOGIN)
    } else if (!isHomeEnabled) {
      navigate(LOGIN)
    }
  }, [navigate, isSystemAuthenticated, isHomeEnabled])

  return (isSystemAuthenticated && isHomeEnabled) ? <>{children}</> : null
}
